import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { PlanComponent } from './plan.component';
import { AuthGuardService } from '../authentication/auth-guard.service';
import { SubscriptionComponent } from './subscription/subscription.component';
import { MatCardModule } from '@angular/material';
import {MatButtonModule} from '@angular/material/button';
import {MatTableModule} from '@angular/material/table';

const routes: Routes = [
  { path: 'plans', component: PlanComponent, canActivate: [AuthGuardService]}
];


@NgModule({
  declarations: [PlanComponent, SubscriptionComponent],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    MatCardModule,
    MatButtonModule,
    MatTableModule
  ],
  exports: [PlanComponent]
})
export class PlanModule { }
